import React, { useContext, useEffect, useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import { useSelector } from "react-redux";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { OverlayPanel } from "primereact/overlaypanel";

import StatusBadge from "../../StatusBadge";
import StatusChip from "../../StatusChip";
import AddFlagModal from "../../AddFlagModal";
import useTasks from "../../../actions/useTasks";
import { ProcessContext } from "../../ProcessLayoutWrapper";
import CustomeButton from "../../../../../components/Button";
import Timelines from "../../../../../components/Timeline";
import "./milestone.scss";
import useDateTime from "~/hooks/useDateTime";
import { fromZonedTime, toZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { formatDateInEntityTimezone } from "~/utils/dateUtil";
import Timezones from "../../../../../assets/timezone-list.json";
import TaskCommentModal from "../../TaskCommentModal";
import CommentList from "./CommentsList";
import { getStatusOptions, STATUS, StatusKey } from "~/utils/status";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useProcess from "~/Pages/Process/actions/useProcess";
import PayslipUploadCard from "./PayslipUploadCard";
import PayslipFileTypeModal from "./PayslipFileTypeModal";
import PayslipUploadFileModal from "./PayslipUploadFileModal";
import SuccessModal from "./SuccessModal";
import AttachmentConfirmationModal from "~/components/AttachmentConfirmationModal";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import apiService from "~/services/service";
import API_ROUTES from "~/api-routes";
import PayslipApproveCard from "./PayslipApproveCard";
import ToastMessage from "~/components/ToastMessage";
import { usePermission } from "~/hooks/usePermission";

const Milestones = () => {
  const { id } = useParams();
  const actionMenu = useRef(null);
  const toastRefPayslip = useRef(null);
  const processContext = useContext(ProcessContext);
  const formatDate = processContext?.formatDate ?? (() => "");
  const milestonesLoading = processContext?.milestonesLoading ?? false;
  const milestones = processContext?.milestones ?? [];

  // Helper function to replace LSP with Local Team in display text
  const formatDisplayText = (text) => {
    if (!text) return text;
    return text.replace(/\bLSP\b/g, "Local Team");
  };

  const {
    taskUpdate,
    taskstates,
    handleCloseFlagModal,
    handleAddFlag,
    handleChangeFlag,
    setSelectedOwners,
    setSelectedStatuses,
    setSelectedTask,
    setDueDate,
    setIsMenuOpen,
    handleStatusChange,
    handleDueDateChange,
    handleOwnerChange,
    handleMarkedAsComplete,
    addTaskCommentModalHandler,
    closeTaskCommentModalHandler,
    taskCommentChangeHandler,
    addTaskComment,
    fetchCommentList,
    setFiles,
    files,
    errorMessage,
    setErrorMessage,
    setIsTaskCommentModal,
    showAttachmentConfirmation,
    setShowAttachmentConfirmation,
    isRejectPayslip,
    setIsRejectPayslip,
    showInitialCard,
  } = useTasks();

  const {
    process,
    allservices,
    uploadPaylispFiles,
    payslipFiles,
    setPayslipFiles,
    isLoading,
    setIsLoading,
    fileSupported,
    getFileSizeMB,
    tryAgainHandler,
    isPayslipProcessingDone,
    reset,
    fetchPayslipMatching,
    loading,
    isDataAvailable,
    paySlipMatchingResult,
    releaseMatchingResult,
    employeesData,
    fetchEmployees,
    setLoading,
    setIsDataAvailable,
    setPaySlipMatchingResult,
    isPayrollPlus,
    errorToastRef,
  } = useProcess();
  const { value: isPayslipUploadFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.PAYSLIP_UPLOAD,
    false,
  );
  const entity = useSelector((state) => state.process?.processdata?.entityData);
  const { processmilestones } = useSelector((state) => state.milestones);
  const { allowed: canApprovePayslip } = usePermission(
    "payslip",
    "approve",
    process?.id ?? "new",
    { entity_id: entity?.id ?? process?.entity },
    { skip: !process?.id },
  );
  const activeIndexRef = useRef({});
  const [activeIndex, setActiveIndex] = useState({});
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const { role } = useSelector((state) => state.login);
  const { dateTimeToTimezone, formatDateTime } = useDateTime();

  const [searchParams, setSearchParams] = useSearchParams();
  const milestoneId = searchParams.get("milestoneId");
  const milestoneRef = useRef({});
  const dropdownRefs = useRef({});
  const [isPayslipFileTypeModalOpen, setIsPayslipFileTypeModalOpen] =
    useState(false);
  const [isPayslipUploadModalOpen, setIsPayslipUploadModalOpen] =
    useState(false);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [fileType, setFileType] = useState("single");
  const navigate = useNavigate();

  const formatCommentDate = (dateString) => {
    let formattedNewDate = formatDateTime({
      date: dateString,
      dateformat: "MMMM d, yyyy 'at' H:mm",
    });
    return formattedNewDate;
  };
  const onApprove = async (tasksdata) => {
    try {
      setIsApproveLoading(true);
      const result = await releaseMatchingResult();
      if (result) {
        const rowdata = tasksdata?.filter(
          (data) => data?.name === "Release of payslips",
        );
        handleStatusChange({ code: "completed" }, rowdata[0], () => {
          setIsApproveLoading(false);
        });
      } else {
        setIsApproveLoading(false);
      }
    } catch (error) {
      console.log("Error Approving Results", error);
      setIsApproveLoading(false);
    }
  };
  const commentOverlayRef = useRef(null);
  const calendarRefs = useRef({});

  const handleHideCommentList = () => {
    if (commentOverlayRef.current) {
      commentOverlayRef.current.hide();
    }
    setSelectedTask({});
  };
  const handleToggleAccordian = (milestoneId) => {
    // Use milestone ID instead of index to maintain state across re-renders
    activeIndexRef.current = {
      ...activeIndexRef.current,
      [milestoneId]: !activeIndexRef.current[milestoneId],
    };
    setActiveIndex(activeIndexRef.current);
  };

  useEffect(() => {
    if (milestones && milestones.length > 0) {
      const initialOwners = {};
      const initialStatuses = {};
      // const activeIndexstate = {};
      const initialDueDate = {};

      milestones.map((milestone, milestoneIndex) => {
        // activeIndexstate[milestoneIndex] = false;
        if (milestone.taskData.length > 0) {
          initialStatuses[milestoneIndex] = {};
          initialOwners[milestoneIndex] = {};
          initialDueDate[milestoneIndex] = {};
          milestone.taskData.map((task) => {
            const taskId = task.id;

            initialDueDate[milestoneIndex][taskId] = task.due_date;
            initialOwners[milestoneIndex][taskId] =
              ownerOption.find((opt) => opt.code === task.owner) || null;

            initialStatuses[milestoneIndex][taskId] = statusOption.find(
              (opt) => opt.code === task.status,
            ) || {
              name: task.status,
              code: task.status,
              primary_color: "#000000",
            };
          });
        }
        return milestone;
      });

      // setActiveIndex(activeIndexstate);
      setSelectedOwners(initialOwners);
      setSelectedStatuses(initialStatuses);
      setDueDate(initialDueDate);
    }
  }, [milestones]);

  useEffect(() => {
    if (!milestoneId || milestonesLoading || !milestones?.length) return;

    const milestoneIndex = milestones.findIndex((m) => m.id === milestoneId);

    if (milestoneIndex !== -1) {
      // Use milestone ID as key instead of index
      activeIndexRef.current = {
        ...activeIndexRef.current,
        [milestoneId]: true,
      };
      setActiveIndex(activeIndexRef.current);
      setTimeout(() => {
        const el = milestoneRef.current[milestoneId];
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        searchParams.delete("milestoneId");
        setSearchParams(searchParams);
      }, 100);
    }
  }, [milestoneId, milestonesLoading, milestones]);

  const timelineMarkerTemplate = (item) => {
    return <StatusBadge status={item?.statusData} />;
  };

  const ownerOption = [
    { name: "Customer", code: "Customer" },
    { name: "GXM", code: "GXM" },
    { name: "Local Team", code: "LSP" },
  ];
  const statusOption = getStatusOptions([
    StatusKey.IN_PROGRESS,
    StatusKey.COMPLETED,
    StatusKey.OVERDUE,
    StatusKey.NOT_NEEDED,
    StatusKey.NOT_STARTED,
  ]);
  const handleStatusValue = () => {
    const gxmUser = ["GXM_ADMIN", "GXM_USER", "GXM_MANAGER"];
    if (gxmUser.includes(role)) {
      return statusOption.filter((status) => {
        return (
          status.code === "in-progress" ||
          status.code === "completed" ||
          status.code === "not-started"
        );
      });
    } else {
      return statusOption.filter((status) => {
        return status.code === "completed";
      });
    }
  };
  const handleManage = (e, data) => {
    setSelectedTask(data);
    actionMenu.current.toggle(e);
    setIsMenuOpen(!taskstates?.isMenuOpen);
  };
  const checkUserRole = (owner = "") => {
    if (role === "GXM_ADMIN" || role === "GXM_USER" || role === "GXM_MANAGER") {
      return true;
    } else if (
      (role === "LSP_USER" || role === "LSP_MANAGER") &&
      owner == "LSP"
    ) {
      return true;
    } else if (
      (role === "CUSTOMER" || role === "CUSTOMER_MANAGER") &&
      owner == "Customer"
    ) {
      return true;
    }
  };

  useEffect(() => {
    fetchPayslipMatching();
  }, []);

  const formatDateInEntity = (utcDate) => {
    if (!utcDate) return "-";
    const dateObj = new Date(utcDate);
    return isNaN(dateObj.getTime()) ? "-" : format(dateObj, "MMMM do, yyyy");
  };

  const openPayslipFileTypeModal = () => {
    setIsPayslipFileTypeModalOpen(true);
  };

  const closeFileTypeModal = () => {
    reset();
    setIsPayslipFileTypeModalOpen(false);
  };

  const fileuploadModalHandler = (fileType) => {
    setFileType(fileType);
    closeFileTypeModal();
    setIsPayslipUploadModalOpen(true);
  };
  const closeFileUploadModal = () => {
    reset();
    setIsPayslipUploadModalOpen(false);
    openPayslipFileTypeModal();
  };

  const successModalHandler = () => {
    setIsSuccessModalOpen(true);
    setIsPayslipUploadModalOpen(false);
  };

  const closeSuccessModalHandler = () => {
    reset();
    setIsSuccessModalOpen(false);
    fetchPayslipMatching();
  };

  const navigationHandler = () => {
    navigate(`/process/${id}/conversations/internal`);
  };
  const canActOnOwner = (owner, role) => {
    if (!owner) return false;
    if (role === "GXM_ADMIN") return true;
    const LSP_ROLES = ["LSP_USER", "LSP_MANAGER"];
    const GXM_ROLES = ["GXM_USER", "GXM_MANAGER", "GXM_ADMIN"];
    return (
      (owner === "LSP" && LSP_ROLES.includes(role)) ||
      (owner === "GXM" && GXM_ROLES.includes(role))
    );
  };

  const disableTaskDueDate = () => {
    return ["LSP_USER", "LSP_MANAGER", "CUSTOMER", "CUSTOMER_MANAGER"].includes(
      role,
    );
  };

  const milestoneContentTemplate = (item, index) => {
    const payrollService = allservices.find(
      (service) => service?.name === "Payroll",
    );
    const handleShowPayslipTable = ({
      item,
      process,
      payrollServiceId,
      role,
    }) => {
      const tasks = item?.taskData ?? [];
      const submitTask = tasks.find(
        (t) =>
          t?.name === "Submit final output to Customer" ||
          t?.name === "Submit output to Customer",
      );
      const isValidCard =
        item?.name === "Submit Final Output" &&
        process?.service === payrollServiceId &&
        process?.status !== "completed" &&
        submitTask?.status !== "completed" &&
        isPayslipUploadFeatureEnabled &&
        !["CUSTOMER", "CUSTOMER_MANAGER"].includes(role);

      if (!isValidCard) return { showPayslipTable: false };

      return {
        showPayslipTable: true,
      };
    };

    const handleShowApproveCard = ({
      item,
      process,
      payrollServiceId,
      role,
    }) => {
      const isValidCard =
        item?.name === "Submit Final Output" &&
        process?.service === payrollServiceId &&
        process?.status !== "completed" &&
        isPayslipUploadFeatureEnabled;

      if (!isValidCard)
        return { showApproveCard: false, isApproveButtonEnable: false };
      const tasks = item?.taskData ?? [];
      if (["GXM_ADMIN", "GXM_MANAGER", "GXM_USER"].includes(role)) {
        const submitTask = tasks.find(
          (t) =>
            t?.name === "Submit final output to Customer" ||
            t?.name === "Submit output to Customer",
        );

        const reviewTask = tasks.find((t) => t?.name === "Release of payslips");
        if (submitTask?.status !== "completed") {
          return { showApproveCard: false, isApproveButtonEnable: true };
        } else {
          if (
            reviewTask &&
            reviewTask?.status !== "completed" &&
            paySlipMatchingResult.length
          ) {
            return {
              showApproveCard: true,
              isApproveButtonEnable: canApprovePayslip,
            };
          } else {
            return { showApproveCard: false, isApproveButtonEnable: false };
          }
        }
      }
      if (["CUSTOMER", "CUSTOMER_MANAGER"].includes(role)) {
        const reviewTask = tasks.find((t) => t?.name === "Release of payslips");
        if (reviewTask?.owner !== "Customer")
          return { showApproveCard: false, isApproveButtonEnable: false };

        if (paySlipMatchingResult.length)
          return {
            showApproveCard: reviewTask?.status !== "completed",
            isApproveButtonEnable: true,
          };
      }
      return { showApproveCard: false, isApproveButtonEnable: false };
    };

    const { showPayslipTable } = handleShowPayslipTable({
      item,
      process,
      payrollServiceId: payrollService?.id,
      role,
    });

    const { showApproveCard, isApproveButtonEnable } = handleShowApproveCard({
      item,
      process,
      payrollServiceId: payrollService?.id,
      role,
    });

    const tasks = item?.taskData ?? [];
    const submitTask = tasks.find(
      (t) =>
        t?.name === "Submit final output to Customer" ||
        t?.name === "Submit output to Customer",
    );

    const tasksdata = item?.taskData;
    const dueDateHandler = (e, rowData) => {
      const utcDate = fromZonedTime(e.value, entity?.timezone);
      handleDueDateChange(utcDate.toISOString(), rowData);
    };

    const CalendarFooterTemplate = () => {
      const selectedTimezone = Timezones.find(
        (tz) => tz.value === entity?.timezone,
      );
      return (
        <p className="m-0 p-2">Entity's time zone: {selectedTimezone?.name}</p>
      );
    };

    const hasComments = tasksdata?.some((row) => Number(row.comment_count) > 0);
    const handleDropdown = (rowData) => {
      const dropdownRef = dropdownRefs.current[rowData.id];
      if (dropdownRef?.show) {
        dropdownRef.show();
      } else if (dropdownRef?.input) {
        dropdownRef.input.click();
      }
    };

    return (
      <div key={item.id} ref={(el) => (milestoneRef.current[item.id] = el)}>
        <Accordion
          // Use milestone ID instead of index to maintain state across re-renders
          activeIndex={activeIndexRef.current[item.id] ? 0 : null}
          onTabChange={() => {
            return null;
          }}
          className="timeline__accordian--container"
        >
          <AccordionTab
            headerClassName={tasksdata.length === 0 ? "no-tasks" : ""}
            header={
              <div className="timeline__accordian--tab">
                <div>
                  <span className="flex align-items-center gap-2 w-full">
                    <span className="timeline__label">
                      {formatDisplayText(item?.name)}
                    </span>
                    <StatusChip
                      color={item?.statusData?.primary_color}
                      label={item?.statusData?.name}
                    />
                  </span>
                  <p className="timeline_date">
                    {entity
                      ? formatDateInEntity(item?.due_date)
                      : item?.due_date &&
                          !isNaN(new Date(item?.due_date).getTime())
                        ? format(item?.due_date, "MMMM do, yyyy")
                        : "-"}
                  </p>
                </div>
                {tasksdata?.length > 0 && (
                  <span
                    className="toggle__accordian--text"
                    onClick={() => {
                      handleToggleAccordian(item.id);
                    }}
                  >
                    {activeIndexRef.current[item.id]
                      ? "Hide Tasks"
                      : "View Tasks"}
                  </span>
                )}
              </div>
            }
          >
            {showPayslipTable && !showApproveCard && (
              <PayslipUploadCard
                openModal={openPayslipFileTypeModal}
                processId={id}
                entityId={entity?.id ?? process?.entity}
                data={!showInitialCard ? paySlipMatchingResult : []}
                loading={loading}
                isDataAvailable={isDataAvailable}
                showPayslipTable={showPayslipTable}
                fetchPayslipMatching={fetchPayslipMatching}
                isOwner={canActOnOwner(submitTask?.owner, role)}
                toastRefPayslip={toastRefPayslip}
              />
            )}
            {showApproveCard && (
              <PayslipApproveCard
                processId={id}
                data={paySlipMatchingResult}
                loading={loading || showInitialCard}
                isDataAvailable={isDataAvailable}
                onApprove={onApprove}
                tasksdata={tasksdata}
                isApproveLoading={isApproveLoading}
                employeesData={employeesData}
                isApproveButtonEnable={isApproveButtonEnable}
                process={process}
                fetchEmployees={fetchEmployees}
                setIsTaskCommentModal={setIsTaskCommentModal}
                setSelectedTask={setSelectedTask}
                setIsRejectPayslip={setIsRejectPayslip}
                errorToastRef={errorToastRef}
              />
            )}
            {tasksdata?.length > 0 && (
              <DataTable
                value={tasksdata}
                tableStyle={{ minWidth: "50rem" }}
                className="datatable-milestone w-full pt-2"
                emptyMessage="No results were found"
                rowClassName={(rowData) =>
                  rowData?.flag ? "highlight-row" : ""
                }
              >
                <Column
                  field="name"
                  header="Task"
                  body={(rowData) => (
                    <React.Fragment>
                      {rowData?.flag &&
                        (taskstates?.isUnflagload &&
                        taskstates?.flagForm?.id == rowData?.id ? (
                          <i className="pi pi-spin pi-spinner mr-2"></i>
                        ) : (
                          <i className="pi pi-flag-fill text-warning mr-2 flag-red-icon"></i>
                        ))}
                      {formatDisplayText(rowData?.name)}

                      {rowData?.flag && (
                        <>
                          <span
                            id={`info-icon-${rowData.id}`}
                            className="info-icon ml-1 pi pi-info-circle"
                          />
                          <Tooltip
                            target={`#info-icon-${rowData.id}`}
                            autoHide={false}
                          >
                            <span>
                              There may be times when tickets are flagged to
                              bring attention to a potential risk.{" "}
                              <a
                                className="cursor-pointer"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "inherit",
                                  textDecoration: "underline",
                                }}
                                onClick={() => {
                                  navigate(
                                    `/process/${id}/conversations/public`,
                                  );
                                }}
                              >
                                View details
                              </a>
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </React.Fragment>
                  )}
                />

                {hasComments && (
                  <Column
                    field="comment"
                    header=""
                    body={(rowData) => {
                      if (Number(rowData?.comment_count) > 0) {
                        return (
                          <div className="position-relative">
                            <span
                              aria-controls={`popup_comment_right-${rowData?.id}`}
                              aria-haspopup
                              className="inline-flex p-overlay-badge cursor-pointer"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                if (commentOverlayRef.current) {
                                  commentOverlayRef.current.toggle(e);
                                }
                                fetchCommentList(rowData);
                              }}
                            >
                              <Tag
                                icon="p-tag-icon pi pi-comment m-0"
                                className="inline-flex task-comment__tag"
                              />
                              <Badge
                                value={rowData?.comment_count}
                                severity="danger"
                                className="task-comment__counter"
                              />
                            </span>

                            <OverlayPanel
                              id={`popup_comment_right-${rowData?.id}`}
                              ref={commentOverlayRef}
                              onHide={handleHideCommentList}
                              appendTo={document.body}
                              dismissable={true}
                            >
                              <CommentList
                                count={taskstates?.totalCommentCount}
                                selected={taskstates?.selectedTask}
                                hide={handleHideCommentList}
                                data={taskstates?.commentList}
                                loading={taskstates?.isCommentLoading}
                                formatDateTime={formatCommentDate}
                                hasMore={taskstates?.hasMoreComments}
                                fetchNextPage={() =>
                                  fetchCommentList(
                                    taskstates?.selectedTask,
                                    taskstates?.commentListPage + 1,
                                  )
                                }
                              />
                            </OverlayPanel>
                          </div>
                        );
                      }
                      return null;
                    }}
                  />
                )}

                <Column
                  headerClassName="column-header-owner"
                  header="Owner"
                  body={(rowData, rowProps) => {
                    const milestoneIndex = index;
                    // const taskIndex = rowProps.rowIndex;
                    const currentOwner =
                      taskstates?.selectedOwners[milestoneIndex]?.[rowData?.id];

                    return (
                      <div className="border__none">
                        {isPayrollPlus ? (
                          <p className="p-2 m-0">{currentOwner?.name}</p>
                        ) : (
                          <Dropdown
                            value={currentOwner || null}
                            loading={
                              taskstates?.isLoadOwner &&
                              taskstates?.selectedTask?.id === rowData?.id
                            }
                            onChange={(e) =>
                              handleOwnerChange(e.value, rowData)
                            }
                            disabled={!checkUserRole()}
                            options={ownerOption}
                            optionLabel="name"
                            placeholder="Select an Owner"
                          />
                        )}
                      </div>
                    );
                  }}
                />
                <Column
                  header="Status"
                  field="Status"
                  body={(rowData, rowProps) => {
                    return (
                      <div className="column__container__status border__none">
                        <span
                          className={`status__badge--dot`}
                          style={{
                            backgroundColor:
                              taskstates?.selectedStatuses[index][rowData?.id]
                                ?.primary_color,
                          }}
                        ></span>
                        {isPayrollPlus ? (
                          <p className="p-2 m-0">
                            {
                              taskstates?.selectedStatuses[index][rowData?.id]
                                ?.name
                            }
                          </p>
                        ) : (
                          <div
                            className={`relative ${checkUserRole(rowData?.owner) ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}
                          >
                            <p
                              className="task__status"
                              onClick={() => {
                                if (checkUserRole(rowData?.owner)) {
                                  handleDropdown(rowData);
                                }
                              }}
                            >
                              {
                                taskstates?.selectedStatuses[index][rowData?.id]
                                  ?.name
                              }
                              {taskstates?.isLoadStatus &&
                              taskstates?.selectedTask?.id === rowData?.id ? (
                                <i className="pi pi-spin pi-spinner ml-1 text-base" />
                              ) : (
                                <i className="pi pi-angle-down text-xl font-light ml-1 opacity-70" />
                              )}
                            </p>
                            <Dropdown
                              className="status__dropdown"
                              ref={(el) =>
                                (dropdownRefs.current[rowData.id] = el)
                              }
                              value={
                                taskstates?.selectedStatuses[index][
                                  rowData?.id
                                ] || null
                              }
                              onChange={(e) =>
                                handleStatusChange(e.value, rowData)
                              }
                              loading={
                                taskstates?.isLoadStatus &&
                                taskstates?.selectedTask?.id === rowData?.id
                              }
                              disabled={!checkUserRole(rowData?.owner)}
                              options={
                                (role === "CUSTOMER" ||
                                  role === "CUSTOMER_MANAGER") &&
                                rowData?.owner == "Customer"
                                  ? taskstates?.selectedStatuses[index][
                                      rowData?.id
                                    ]?.name === "Overdue"
                                    ? handleStatusValue()
                                    : statusOption.filter((option) => {
                                        return (
                                          option.code !== "not-needed" &&
                                          option.code !== "overdue"
                                        );
                                      })
                                  : taskstates?.selectedStatuses[index][
                                        rowData?.id
                                      ]?.name === "Overdue"
                                    ? handleStatusValue()
                                    : statusOption.filter(
                                        (option) => option.code !== "overdue",
                                      )
                              }
                              optionLabel="name"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      </div>
                    );
                  }}
                />
                <Column
                  header={() => {
                    return (
                      <div className="due__date--header gap-2 flex align-items-center">
                        Due Date
                        <span
                          className="info-icon ml-1 pi pi-info-circle"
                          id="due_date"
                        />
                        <Tooltip
                          target="#due_date"
                          content="This date and time are based on the entity's time zone, which may differ from your local time."
                          position="bottom"
                          className="calendar-tooltip"
                        />
                      </div>
                    );
                  }}
                  body={(rowData, rowProps) => {
                    if (!calendarRefs.current[rowData.id]) {
                      calendarRefs.current[rowData.id] = React.createRef();
                    }
                    const isTaskLoading =
                      taskstates?.isLoadDate &&
                      taskstates?.selectedTask?.id === rowData?.id;
                    const isStatusValid = rowData?.status !== "not-needed";

                    return (
                      <div
                        className={`due__date ${
                          disableTaskDueDate() && "disabled-content"
                        }`}
                      >
                        {isStatusValid && (
                          <>
                            {formatDateInEntityTimezone(
                              taskstates?.dueDate[index][rowData?.id],
                              entity?.timezone,
                            )}
                            <Calendar
                              ref={
                                checkUserRole(rowData?.owner) &&
                                calendarRefs.current[rowData.id]
                              }
                              style={{}}
                              value={
                                taskstates?.dueDate[index][rowData?.id]
                                  ? toZonedTime(
                                      taskstates?.dueDate[index][rowData?.id],
                                      entity?.timezone,
                                    )
                                  : null
                              }
                              onChange={(e) => dueDateHandler(e, rowData)}
                              disabled={disableTaskDueDate()}
                              placeholder="Select start date"
                              className="w-full milestone__calander"
                              showTime
                              hideOnDateTimeSelect
                              hourFormat="12"
                              footerTemplate={CalendarFooterTemplate}
                            />
                          </>
                        )}
                        {isStatusValid &&
                          !isPayrollPlus &&
                          (isTaskLoading ? (
                            <span>
                              <i className="pi pi-spin pi-spinner mr-2"></i>
                            </span>
                          ) : (
                            <span
                              className={`pi pi-calendar calander__icon--milestone ${
                                disableTaskDueDate() && "disabled-calender"
                              }`}
                              onClick={() => {
                                if (
                                  checkUserRole(rowData?.owner) &&
                                  calendarRefs.current[rowData.id]?.current
                                ) {
                                  calendarRefs.current[
                                    rowData.id
                                  ].current.show();
                                }
                              }}
                            ></span>
                          ))}
                      </div>
                    );
                  }}
                />
                <Column
                  body={(rowData) => {
                    return (
                      <React.Fragment>
                        <Menu
                          className="milestone-dropdown"
                          id="popup_menu_right"
                          popupAlignment="right"
                          popup
                          ref={actionMenu}
                          model={[
                            {
                              label: "Add Comments & Files",
                              icon: "pi pi-comment",
                              command: () =>
                                addTaskCommentModalHandler(
                                  taskstates?.selectedTask,
                                ),
                            },
                            {
                              label: taskstates?.selectedTask.flag
                                ? "Remove Flag"
                                : "Add Flag",
                              icon: taskstates?.isUnflagload
                                ? "pi pi-spin pi-spinner"
                                : taskstates?.selectedTask.flag
                                  ? "pi pi-flag-fill flag-red-icon"
                                  : "pi pi-flag-fill",
                              command: () =>
                                handleAddFlag(
                                  taskstates?.selectedTask,
                                  taskstates?.selectedTask.flag,
                                ),
                            },
                            ...(!isPayrollPlus
                              ? [
                                  {
                                    label: "Mark as Completed",
                                    icon: "pi pi-pen-to-square",
                                    command: () =>
                                      handleMarkedAsComplete(
                                        taskstates?.selectedTask,
                                        taskstates?.selectedTask.flag,
                                      ),
                                    disabled:
                                      taskstates?.selectedTask?.status ==
                                      "completed",
                                  },
                                ]
                              : []),
                          ]}
                          onHide={() => setIsMenuOpen(false)}
                        />
                        <CustomeButton
                          icon="pi pi-ellipsis-v"
                          aria-controls="popup_menu_right"
                          variant="no-outlined"
                          aria-haspopup
                          className={
                            taskstates?.isMenuOpen &&
                            rowData?.id === taskstates?.selectedTask?.id
                              ? "highlight"
                              : ""
                          }
                          disabled={!checkUserRole(rowData?.owner)}
                          onClick={(e) => handleManage(e, rowData)}
                        />
                      </React.Fragment>
                    );
                  }}
                />
              </DataTable>
            )}
          </AccordionTab>
        </Accordion>
      </div>
    );
  };

  const handleAddTaskComment = async (taskId) => {
    if (isRejectPayslip) {
      setLoading(true);
      await addTaskComment(taskId, paySlipMatchingResult, processmilestones);
      setIsDataAvailable(false);
      setPaySlipMatchingResult([]);
      setLoading(false);
    } else await addTaskComment(taskId);
  };

  return (
    <div className="milestone__body">
      {milestonesLoading ? (
        <>
          <Skeleton width="w-full" height="7rem" className="mb-2"></Skeleton>
          <Skeleton width="w-full" height="7rem" className="mb-2"></Skeleton>
          <Skeleton width="w-full" height="7rem" className="mb-2"></Skeleton>
        </>
      ) : (
        <div className="milestone__timeline">
          <Timelines
            events={milestones || []}
            markerTemplate={timelineMarkerTemplate}
            contentTemplate={milestoneContentTemplate}
          />
        </div>
      )}

      {taskstates?.isaddflagmodal && (
        <AddFlagModal
          show={taskstates?.isaddflagmodal}
          data={taskstates?.flagForm}
          onChange={handleChangeFlag}
          onCancel={handleCloseFlagModal}
          onConfirm={taskUpdate}
          isLoading={taskstates?.isTaskUpdateLoad || false}
          flagComment={taskstates?.flag_comment}
          isRemoveFlag={taskstates?.isremoveFlag}
        />
      )}

      {taskstates?.isTaskCommentModal && (
        <TaskCommentModal
          visible={taskstates?.isTaskCommentModal}
          onCancel={closeTaskCommentModalHandler}
          task={taskstates.selectedTask}
          onChange={taskCommentChangeHandler}
          data={taskstates?.taskCommentData}
          taskCommentData={taskstates?.taskCommentData}
          onConfirm={handleAddTaskComment}
          isLoading={taskstates?.isCommentsLoading}
          showSuccess={taskstates?.isSuccessComment}
          isError={taskstates?.isCommentError}
          setIsError={taskstates?.setIsCommentError}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          setFiles={setFiles}
          files={files}
          setIsTaskCommentModal={setIsTaskCommentModal}
          setShowAttachmentConfirmation={setShowAttachmentConfirmation}
        />
      )}

      {isPayslipFileTypeModalOpen && (
        <PayslipFileTypeModal
          visible={isPayslipFileTypeModalOpen}
          closeModal={closeFileTypeModal}
          openFileUploadModal={fileuploadModalHandler}
        />
      )}
      {isPayslipUploadModalOpen && (
        <PayslipUploadFileModal
          visible={isPayslipUploadModalOpen}
          closeModal={closeFileUploadModal}
          uploadPaylispFiles={uploadPaylispFiles}
          payslipFiles={payslipFiles}
          setPayslipFiles={setPayslipFiles}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isPayslipFile={true}
          fileSupported={fileSupported}
          getFileSizeMB={getFileSizeMB}
          openSuccessModal={successModalHandler}
          tryAgainHandler={tryAgainHandler}
          isPayslipProcessingDone={isPayslipProcessingDone}
          fileType={fileType}
        />
      )}

      {isSuccessModalOpen && (
        <SuccessModal
          closeSuccessModal={closeSuccessModalHandler}
          visible={isSuccessModalOpen}
          onNavigate={navigationHandler}
        />
      )}
      <AttachmentConfirmationModal
        showModal={showAttachmentConfirmation}
        handleCloseModal={() => {
          setShowAttachmentConfirmation(false);
          setIsTaskCommentModal(true);
        }}
        handleConfirm={() => handleAddTaskComment(taskstates?.selectedTask.id)}
        isLoading={taskstates?.isCommentsLoading}
      />
      <ToastMessage ref={toastRefPayslip} />
    </div>
  );
};

export default Milestones;
